<div class="bug-report-modal" [class.visible]="isVisible">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-scrollable">
      <div class="modal-header">
        <button class="close-btn" (click)="close()"></button>
        <div class="header-content">
          <img src="assets/icons/bug_report.svg" alt="Bug report" class="bug-icon">
          <h2>Kako vam lahko pomagamo?</h2>
        </div>
      </div>
      
      <div class="modal-body">
        <p class="subtitle">Prijavi napako ali postavi vprašanje</p>
        <p class="description">Čim bolj podrobno opišite težavo, ki jo imate in pripnite silko težave.</p>
      
      <form [formGroup]="form" (submit)="submit()">
        <div class="form-group">
          <label for="email">E-poštni naslov</label>
          <input id="email" type="email" formControlName="email" required>
        </div>
        
        <div class="form-group">
          <label for="subject">Zadeva</label>
          <input id="subject" type="text" formControlName="subject" required>
        </div>
        
        <div class="form-group">
          <label for="description">Opis</label>
          <textarea id="description" formControlName="description" rows="5" required 
                    (input)="autoResize($event)" 
                    (keyup)="autoResize($event)" 
                    (paste)="autoResize($event)"
                    (cut)="autoResize($event)"></textarea>
        </div>
        
        <div class="form-group">
          <label>Priponke</label>
          <div class="file-input-wrapper">
            <input type="file" (change)="onFileSelected($event)" accept="image/*,.pdf,.doc,.docx" multiple #fileInput>
            <span class="file-hint" (click)="fileInput.click(); $event.stopPropagation()">+ Priloži datoteko(e)</span>
            <div class="file-names" *ngIf="selectedFiles.length > 0">
              <div class="file-item" *ngFor="let file of selectedFiles; let i = index">
                <span class="file-name">{{ file.name }}</span>
                <button type="button" class="remove-file-btn" (click)="removeFile(i); $event.stopPropagation()" title="Odstrani datoteko"></button>
              </div>
            </div>
            <div class="file-name" *ngIf="selectedFiles.length === 0">Ni izbranih datotek</div>
          </div>
        </div>
        
        <div class="success-message" *ngIf="emailSent">
          Vaša prijava napake je bila uspešno poslana!
        </div>
        
        <div class="error-message" *ngIf="emailError">
          Prišlo je do napake pri pošiljanju. Poskusite znova kasneje.
        </div>
        
        <div class="form-actions">
          <button type="submit" class="import-button" [disabled]="form.invalid || isLoading">
            <span *ngIf="!isLoading">POŠLJI</span>
            <span *ngIf="isLoading">POŠILJAM...</span>
          </button>
        </div>
      </form>
      </div>
    </div>
  </div>
</div>
